import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {mostrarClienteById, mostrarClientes} from "../../redux/reducers/clientesReducer";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Rating,
  TableBody,
  TableCell,
  TableRow,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  AppBar,
  ButtonResponsive,
  ClientCard,
  ClientListItem,
  FilteredAlert,
  ListViewMode,
  LoadingProgress,
  MostrarError,
  Pagination,
  PlusFab,
  SeacrhAppBar,
  TableSort
} from '../../components';
import {SelectEnum, SelectRuta} from "../../components/selects";
import Strings from "../../assets/strings";
import ContactDetails from "./ContactDetails";
import {formatPeso, hasPermissionTo, PERSMISOS} from "../../helpers";
import {CloudDownloadOutlined, CloudUploadOutlined, FilterList} from "@mui/icons-material";
import downloadFiles from "../../helpers/downloadFiles";
import DefaultImgEmp from "../../assets/img/defaultAvatar_empresa.jpg";
import NoImg from "../../assets/img/defaultAvatar.jpg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IClienteFilter} from "../../redux/types/ICliente";
import ImportarCliente from "./ImportarCliente";
import TopBarDialog from "../../components/topBar/TopBarDialog";

const useStyles = makeStyles((theme:Theme) => ({
  toolbar: theme.mixins.toolbar,
  item:{
    [theme.breakpoints.down('md')]: {
      padding: "0px !important",
    },
  },
  status:{
    display: "block",
    width: 10,
    height: 10,
    background: "gray",
    border: "2px solid #fff",
    borderRadius: "50%",
    position: "absolute",
    right: 5,
    bottom: 5,
    "&.e0":{
      background: "red"
    },
    "&.e1":{
      background: "#01a855"
    },
    "&.e2":{
      background: "orange"
    }
  },
  nombre:{
    "&>div":{
      display: "flex",
      alignItems: "center",
      "&>span":{
        marginRight: 8,
        //  float: "left",
        "&>div":{
          height: 31,
          width: 31,
        }
      },
      "& p":{
        lineHeight: 1,
      },
      "& .MuiRating-decimal":{
        fontSize: 14,
      }
    }
  }
}));

const initialState:IClienteFilter={
  name: '',
  rutaId:undefined,
  estado: undefined,
  page:1,
  pageSize:15,
  orderBy:"",
  orderByIsDescending:undefined
};
export default function Clientes(){
  let navigate = useNavigate();
  let location = useLocation();
  let dispatch = useAppDispatch();
  let {list,error, status,filtered} = useAppSelector(state => state.clientes);
  let {viewTableList} = useAppSelector(state => state.theme);

  const [showMenuOpcion, setShowMenuOpcion] = useState(null);

  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const classes = useStyles();
  const [openFilter, setOpenFilter] = useState(false);
  const [importModal, setImportModal] = useState(false);

  const [filter, setFilter] = useState(initialState);


  const isEmpty = (!list?.items || list.items.length === 0);

  useEffect(() => {
    dispatch(mostrarClientes());
  }, [dispatch]);
  //set filtered params
  useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])

  const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    if(name === "name" || name === "page" || name === "pageSize"){
      return dispatch(mostrarClientes({
        ...filter,
        page:1,
        ...(name === "name" && {estado: undefined}),
        [name]:value
      }));
    }
    setFilter({...filter,page:1,[name]:value})
  };
  const resetFilter = () => {
    setOpenFilter(false);
    setFilter(initialState);
    dispatch(mostrarClientes({}));
  };
  const searchFilter = () => {
    setOpenFilter(false);
    dispatch(mostrarClientes(filter));
  };
  const tableSortProps = (orderBy:string) => {
    return {
      active:filter.orderBy === orderBy,
      direction: filter.orderByIsDescending ? "desc" : 'asc',
      onClick:()=>dispatch(mostrarClientes({...filter,page:1,orderBy,orderByIsDescending:!filter.orderByIsDescending}))
    };
  };
  const showClientModal = (cliId:number) => {
    dispatch(mostrarClienteById(cliId));
    navigate(location.pathname, {state:{cliente:{id:cliId}}});
  };

  return <>
    <AppBar/>
    <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} fullWidth maxWidth={"xs"}>
      <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SelectEnum
                label={Strings.estado}
                group="estadosCliente"
                name= 'estado'
                // all
                value={filter.estado}
                onChange={handleFilter}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectRuta
                label={Strings.ruta}
                name= 'rutaId'
                value={filter.rutaId}
                all
                onChange={handleFilter}
            />
          </Grid>
        </Grid>
        <br/>
      </DialogContent>
      <DialogActions>
        <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
          {Strings.restablecer}
        </Button>
        <Button color="primary" variant={"outlined"} onClick={searchFilter} >{Strings.filtrar}</Button>
      </DialogActions>
    </Dialog>

    <section className="contentInner" style={status === "loading" ?{opacity:.8}:{opacity:1}}>
      {status === "loading" && <LoadingProgress vh/>}
      {error && <MostrarError errors={error}/>}

      <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount} lg>
        <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter} />
        <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(true)}/>


        <ButtonResponsive icon={<CloudDownloadOutlined/>} text={"Opciones"} onClick={(e:any) => setShowMenuOpcion(e.currentTarget)}/>


        <Menu
            anchorEl={showMenuOpcion}
            open={Boolean(showMenuOpcion)}
            onClose={() => setShowMenuOpcion(null)}
        >

          <MenuItem
              disabled={isEmpty}
              onClick={() => {
                setShowMenuOpcion(null);
                downloadFiles(filter,"clientes")
              }}
          >
            <ListItemIcon>
              <CloudDownloadOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{Strings.exportar}</ListItemText>
          </MenuItem>

          <MenuItem
              onClick={() => {
                setShowMenuOpcion(null);
                setImportModal(true)
              }}
          >
            <ListItemIcon>
              <CloudUploadOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{Strings.importar}</ListItemText>
          </MenuItem>

        </Menu>
        <FilteredAlert onClose={resetFilter} filter={filtered}/>
      </ListViewMode>

      {viewTableList?(
          <TableSort data={[
            // {pro:"cliEstado",text:Strings.estado},
            {pro:"nombres",text:Strings.cliente},
            // {pro:"calificacion",text:Strings.calificacion},
            {pro:"cedula",text:Strings.cedula},
            {pro:"capitalPendiente",text:Strings.capitalPendiente, align: "right"},
            {pro:"balancePendiente",text:Strings.balance+" "+Strings.pendiente, align: "right"},
            {pro:"ingresos",text:Strings.ingreso, align: "right"},
            {pro:"celular",text:Strings.celular},
            {pro:"telefono",text:Strings.telefono},
            {pro:"ruta",text:Strings.ruta},
            {pro:"direccion",text:Strings.direccion},
          ]} onSort={tableSortProps} lessVh={144}>
            <TableBody>
              {!isEmpty && list?.items?.map(cliente =>
                  <TableRow key={cliente.id} onClick={()=>showClientModal(cliente.id!)}>
                    {/*<TableCell><span className={classes.status +" e"+ cliente.cliEstado} >{Strings[cliente.cliEstadoString]}</span></TableCell>*/}
                    <TableCell className={classes.nombre}>
                      <div>
                        <Badge
                            classes={{badge:classes.status +" e"+ cliente.estado}}
                            color={"secondary"}
                            variant={"dot"}
                            overlap="circular"
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                        >
                            <Avatar alt="" src={ cliente.avatar?cliente.avatar: (cliente.tipo === 2 ?DefaultImgEmp: NoImg)}/>
                        </Badge>
                        <div>
                          <Typography>{cliente.nombres +" "+cliente.apellidos}</Typography>
                          <Box display={"flex"} alignItems="center">
                            <Rating value={cliente.calificacion || 0} precision={0.5} size="small" readOnly /> &nbsp;
                            <Typography variant={"caption"}>{cliente.calificacion}</Typography>
                          </Box>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{cliente.cedula}</TableCell>
                    <TableCell align={"right"}>{formatPeso(cliente.capitalPendiente)}</TableCell>
                    <TableCell align={"right"}>{formatPeso(cliente.balancePendiente)}</TableCell>
                    <TableCell align={"right"}>{formatPeso(cliente.ingresos)}</TableCell>
                    <TableCell>{cliente.celular}</TableCell>
                    <TableCell>{cliente.telefono}</TableCell>
                    <TableCell>{cliente.ruta}</TableCell>
                    <TableCell className="comment"><span>{cliente.direccion}</span></TableCell>
                  </TableRow>
              )}
            </TableBody>
          </TableSort>
      ):(
          smVewport ?(
              <List>
                {!isEmpty && list?.items?.map((cliente, index) => (
                    <ClientListItem key={cliente.id}
                                    timeout={+(index+"000") / 3}
                                    cliente={cliente}
                                    onClick={()=>
                                      showClientModal(cliente.id!)
                                    }
                    />
                ))}
              </List>
          ):(
              <>
                {!!list?.items.length &&
                    <Grid container spacing={3}>
                      {list?.items?.map(cliente => (
                          <Grid key={cliente.id} item xs={12} sm={6} md={4} lg={3} className={classes.item}>
                            <ClientCard  onClick={()=>showClientModal(cliente.id!)} cliente={cliente} />
                          </Grid>
                      ))}
                    </Grid>
                }
              </>
          )
      )}



      {!!list &&
          <Pagination
              empty={Boolean(isEmpty && status !== "loading")}
              count={list.totalCount || 0}
              page={list.pageNumber - 1}
              rowsPerPage={filter.pageSize??15}
              onPageChange={(e, page) => {
                dispatch(mostrarClientes({...filter,page:page + 1}));
              }}
              onRowsPerPageChange={handleFilter}
          />
      }

      <ContactDetails />
    </section>
    {hasPermissionTo(PERSMISOS.clientesCrear) &&
    <PlusFab component={Link} to="/crear/cliente" />
    }

    <ImportarCliente open={importModal} onClose={()=>setImportModal(false)}/>
  </>;
}


